import React from 'react'
import { Tabs } from 'antd'
import ProtectionConfig from '../../components/ProtectionConfig'
import DutyShiftTab from './DutyShiftTab'
import UnitTab from './UnitTab'
import RewardConfigTab from './RewardConfigTab'
import AuditLogTab from './AuditLogTab'
import AccountTab from './AccountTab'
import { useAuthStore, AdminRole } from '../../stores/auth'
import { hasPermission } from '../../utils/permissions'

/**
 * 复刻本次改动前 /system-config 的可见角色集（保护期/楼盘字典/奖励 三个 tab 沿用）。
 * 注意：这只是页面级兼容常量，不是权限真源 —— 权限真源仍为 utils/permissions.ts。
 */
const SYSCONFIG_LEGACY_ROLES: AdminRole[] = ['super_admin', 'admin', 'leasing_manager']

/**
 * 系统配置中心（tab 子页）：
 * 保护期配置 / 值班排班（小时级）/ 楼盘字典 / 奖励规则+小程序内容 / 操作日志 / 账号管理
 * 说明：账号管理（admin_users RBAC）已实现端到端（列表全量可见，新建/改角色/重置密码/
 * 删除仅 super_admin 可操作，后端同步鉴权）；角色体系于业务规则 v2 冻结 5 角色，
 * R4 追加第 6 角色 leasing_director（招商总监）。新建/改角色弹窗内联「权限速览」。
 */
const SystemConfigPage: React.FC = () => {
  const role = useAuthStore((s) => s.user?.role)
  const isLegacy = !!role && (SYSCONFIG_LEGACY_ROLES as string[]).includes(role)
  // account_self_v1（2026-09-23）：全 8 角色可进入本页，按角色/权限过滤 tab；
  // SA/A/LM 结果与改动前完全一致（6 个 tab、同顺序）；其余角色至少可见「账号管理」（仅本人）
  const items = [
    { key: 'protection', label: '保护期配置', children: <ProtectionConfig />, visible: isLegacy },
    { key: 'duty', label: '值班排班', children: <DutyShiftTab />, visible: hasPermission(role, 'DUTY_VIEW') },
    { key: 'units', label: '楼盘字典', children: <UnitTab />, visible: isLegacy },
    { key: 'reward', label: '奖励与小程序内容', children: <RewardConfigTab />, visible: isLegacy },
    { key: 'audit', label: '操作日志', children: <AuditLogTab />, visible: hasPermission(role, 'AUDIT_VIEW') },
    { key: 'accounts', label: '账号管理', children: <AccountTab />, visible: true },
  ]
    .filter((t) => t.visible)
    .map(({ visible: _v, ...t }) => t)
  // 未指定 activeKey 时 antd Tabs 默认选中第一个可见项，过滤后无需额外兜底
  return <Tabs items={items} />
}

export default SystemConfigPage
